import { Link } from "react-router-dom";
import { ShoppingCart, Search, ChevronDown } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useState } from "react";
import logoImage from "../assets/569e6945d915e970c13e6d9d28786ddb.jpg";

export default function Navbar() {
  const { cart } = useCart();
  const [langOpen, setLangOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState("ar");

  const languages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "ar", name: "Arabic", flag: "🇸🇦" },
    { code: "fr", name: "French", flag: "🇫🇷" },
    { code: "zh", name: "Chinese", flag: "🇨🇳" },
    { code: "ru", name: "Russian", flag: "🇷🇺" },
  ];

  const totalQuantity = cart.reduce((sum, item) => sum + (item.quantity || 1), 0);

  const handleLangSelect = (code) => {
    setCurrentLang(code);
    setLangOpen(false);
    // Optionally, add logic to switch app language here
  };

  return (
    <section className="py-4 lg:py-6 bg-transparent sticky top-0 z-50">
      <div className="container max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-2 lg:grid-cols-3 items-center gap-4 border border-black/10 rounded-full p-2 md:p-3 bg-white">
          
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <img src={logoImage} alt="Logo" className="h-12 md:h-16 w-auto" />
            </Link>
          </div>

          {/* Search Bar */}
          <div className="hidden lg:flex justify-center">
            <div className="flex items-center w-full max-w-md bg-gray-100 rounded-full px-4 py-2 shadow-sm hover:shadow-md transition">
              <Search className="w-5 h-5 text-gray-500 mr-2" />
              <input
                type="text"
                placeholder="Search for products or services..."
                className="bg-transparent w-full focus:outline-none text-gray-700 placeholder-gray-400"
              />
            </div>
          </div>

          {/* Right Section */}
          <div className="flex justify-end gap-4 items-center relative">
            {/* Cart Icon */}
            <Link
              to="/cartPage"
              className="relative inline-flex items-center p-2 rounded-full hover:bg-gray-100 transition"
            >
              <ShoppingCart className="w-6 h-6 text-gray-700 hover:text-black transition" />
              {totalQuantity > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full shadow">
                  {totalQuantity}
                </span>
              )}
            </Link>

            {/* Language Dropdown */}
            <div className="relative">
              <button
                onClick={() => setLangOpen(!langOpen)}
                className="inline-flex items-center px-4 py-2 rounded-full bg-gray-500 text-white text-sm font-medium hover:bg-red-600 transition whitespace-nowrap"
              >
                {languages.find((l) => l.code === currentLang)?.flag}{" "}
                {languages.find((l) => l.code === currentLang)?.code.toUpperCase()}
                <ChevronDown className="w-4 h-4 ml-1" />
              </button>

              {langOpen && (
                <ul className="absolute right-0 mt-2 w-40 bg-white border rounded-lg shadow-lg overflow-hidden z-50">
                  {languages.map((lang) => (
                    <li
                      key={lang.code}
                      className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => handleLangSelect(lang.code)}
                    >
                      <span>{lang.flag}</span>
                      <span>{lang.name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}